import { DoorOperationType } from "building-types/doors/doorOperationTypes";
import type { DoorDescriptor } from "building-types/doors/doorTypes";
import { SwingSide } from "building-types/doors/doorTypes";
import type { PropAttributeTable } from "building-types/props/propTypes";
import { GLTF_ASSET_SCALE } from "common/constants/assetConstants";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import type { MergedPropLibrary } from "doc/propTools";
import type { Vec2 } from "geom/vec2";
import { vec2Perp } from "geom/vec2";

export function inchesToFeetInches(l: number): [number, number] {
  const feet = (l / 12) | 0;
  const inches = l - feet * 12;

  return [feet, inches];
}

export async function propPlacementSwingAdjust(
  descriptor: DoorDescriptor,
  propId: string,
  swingSide: SwingSide,
  wallNormX: number,
  wallNormY: number,
  propCatalog: PropAttributeTable,
  mergedPropLibrary: MergedPropLibrary,
): Promise<Vec2> {
  if (swingSide !== SwingSide.LEFT) {
    return [0, 0];
  }

  let adjust = 0;

  if (
    descriptor.operationType === DoorOperationType.WALL_MOUNTED ||
    descriptor.operationType === DoorOperationType.BI_FOLD
  ) {
    //adjust by door width
    adjust = -descriptor.width;
  } else {
    //adjust by prop width
    const prop = await mergedPropLibrary.get(propCatalog[propId].propAssetId);
    assertIsNotNullOrUndefined(prop);
    adjust = -prop.boundingBox.maxX * GLTF_ASSET_SCALE;
  }

  const [perpX, perpY] = vec2Perp(wallNormX, wallNormY);

  return [-adjust * perpX, -adjust * perpY];
}
